/**
 * Vídeos arqueados — autoplay mudo em sincronia; clique abre modal com som (controles nativos).
 */
(function () {
  var modal = null;
  var modalVideo = null;
  var modalTitle = null;
  var modalMuteBtn = null;
  var modalReady = false;

  function syncModalMuteButton(unmuted) {
    if (!modalMuteBtn) return;
    modalMuteBtn.classList.toggle('is-unmuted', unmuted);
    modalMuteBtn.setAttribute('aria-pressed', unmuted ? 'true' : 'false');
    modalMuteBtn.setAttribute(
      'aria-label',
      unmuted ? modalMuteBtn.dataset.labelMute || 'Silenciar vídeo' : modalMuteBtn.dataset.labelUnmute || 'Ativar som'
    );
  }

  function applyModalMuteState() {
    if (!(modalVideo instanceof HTMLVideoElement)) return;
    var unmuted = !!(modalMuteBtn && modalMuteBtn.classList.contains('is-unmuted'));
    modalVideo.muted = !unmuted;
    if (unmuted) {
      modalVideo.removeAttribute('muted');
    } else {
      modalVideo.setAttribute('muted', '');
    }
  }

  function getVideoSrc(video) {
    if (!video) return '';
    if (video.currentSrc) return video.currentSrc;
    var source = video.querySelector('source');
    if (source && source.src) return source.src;
    return video.src || '';
  }

  function gridVideos(root) {
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll('.md-pdp-jewelry-videos__video'));
  }

  function lockGridVideo(video) {
    if (!video || video === modalVideo) return;
    video.muted = true;
    video.defaultMuted = true;
    video.controls = false;
    video.removeAttribute('controls');
  }

  function playGridVideos(videos, shouldPlay) {
    videos.forEach(function (video) {
      lockGridVideo(video);
      video.playsInline = true;
      video.loop = true;
      if (shouldPlay) {
        video.play().catch(function () {});
      } else {
        video.pause();
      }
    });
  }

  function ensureModal() {
    if (modal) return !!modalVideo;

    var modals = document.querySelectorAll('[data-md-jewelry-video-modal]');
    for (var i = 1; i < modals.length; i += 1) {
      modals[i].remove();
    }

    modal = document.querySelector('[data-md-jewelry-video-modal]');
    if (!modal) return false;

    modalVideo = modal.querySelector('[data-md-jewelry-video-modal-player]');
    modalTitle = modal.querySelector('[data-md-jewelry-video-modal-title]');
    modalMuteBtn = modal.querySelector('[data-md-jewelry-video-mute]');
    if (!modalVideo) return false;

    if (!modalReady) {
      modalReady = true;

      if (modalMuteBtn) {
        modalMuteBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (!(modalVideo instanceof HTMLVideoElement)) return;
          var unmuted = !modalMuteBtn.classList.contains('is-unmuted');
          syncModalMuteButton(unmuted);
          applyModalMuteState();
          if (unmuted) modalVideo.play().catch(function () {});
        });
      }

      modal.querySelectorAll('[data-md-jewelry-video-close]').forEach(function (btn) {
        btn.addEventListener('click', closeModal);
      });

      modal.addEventListener('cancel', function (event) {
        event.preventDefault();
        closeModal();
      });

      modal.addEventListener('click', function (event) {
        if (event.target === modal) closeModal();
      });
    }

    return true;
  }

  function closeModal() {
    if (!modal || !modal.open) return;

    modalVideo.pause();
    modalVideo.removeAttribute('src');
    modalVideo.load();
    modal.close();
    document.body.classList.remove('md-pdp-jewelry-video-modal-open');
  }

  function openModal(sourceVideo, title) {
    if (!ensureModal()) return;

    var src = getVideoSrc(sourceVideo);
    if (!src) return;

    document.querySelectorAll('.md-pdp-jewelry-videos__video').forEach(lockGridVideo);

    modalVideo.src = src;
    modalVideo.loop = true;
    modalVideo.playsInline = true;
    modalVideo.controls = true;
    syncModalMuteButton(false);
    applyModalMuteState();

    if (modalTitle) {
      modalTitle.textContent = title || '';
      modalTitle.hidden = !title;
    }

    modal.showModal();
    document.body.classList.add('md-pdp-jewelry-video-modal-open');
    modalVideo.play().catch(function () {});
  }

  function trimJewelryCards(strip) {
    var grid = strip.querySelector('.md-pdp-jewelry-cards__grid');
    if (!grid) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll('.md-pdp-jewelry-cards__item'));
    var kept = [];

    items.forEach(function (item) {
      var heading = item.querySelector('.md-pdp-jewelry-cards__heading');
      var text = heading ? heading.textContent.trim().toLowerCase() : '';
      if (text === 'envio e garantia') {
        item.remove();
        return;
      }
      kept.push(item);
    });

    kept.forEach(function (item, index) {
      var num = item.querySelector('.md-pdp-jewelry-cards__num');
      if (!num) return;
      var label = String(index + 1);
      num.textContent = label.length < 2 ? '0' + label : label;
    });
  }

  function bindTriggers(strip) {
    strip.querySelectorAll('[data-md-jewelry-video-open]').forEach(function (trigger) {
      if (trigger.dataset.mdJewelryVideoBound === '1') return;
      trigger.dataset.mdJewelryVideoBound = '1';

      trigger.addEventListener('click', function () {
        var video = trigger.querySelector('.md-pdp-jewelry-videos__video');
        if (!video) return;
        openModal(video, trigger.getAttribute('data-md-jewelry-video-title') || '');
      });
    });
  }

  function initStrip(strip) {
    if (strip.dataset.mdJewelryStripInit === '1') return;
    strip.dataset.mdJewelryStripInit = '1';

    trimJewelryCards(strip);

    var videos = gridVideos(strip);
    if (!videos.length) return;

    videos.forEach(function (video) {
      lockGridVideo(video);
      video.addEventListener('volumechange', function () {
        lockGridVideo(video);
      });
    });

    bindTriggers(strip);

    var isPlaying = false;

    function setAllPlaying(shouldPlay) {
      if (isPlaying === shouldPlay) return;
      isPlaying = shouldPlay;
      playGridVideos(videos, shouldPlay);
    }

    if (typeof IntersectionObserver === 'undefined') {
      setAllPlaying(true);
      return;
    }

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          setAllPlaying(entry.isIntersecting);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -4% 0px' }
    ).observe(strip);
  }

  function boot() {
    ensureModal();
    document.querySelectorAll('[data-md-jewelry-strip]').forEach(initStrip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
